import Icon from '../components/Icon.vue'

Icon.register({
  bacon: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M218.9 336.4c-34.9 34.9-59.7 44.2-85.9 54-26 9.8-53 20.1-88.2 52.7l-35.8-35.5c-12.7-12.6-12.1-33.6 1.8-45.1 36.3-30 66.2-41.1 91.1-50.4 9.2-3.4 69-19.3 98.7-98.1 8.6-22.8 46.3-134.6 189-187.7 15.9-5.9 27.4-10.2 41-20.3 4.5-3.4 12.8-6.1 18.4-6.1 7 0 16.8 4 21.7 8.9l37.7 37.4c-30.2 27.7-52.9 36.4-76.8 45.4-28.3 10.6-57.6 21.6-97.4 61.4s-50.8 69-61.4 97.3c-9.8 26.3-19.2 51.1-54 86zM566.9 104.4c12.7 12.6 12.1 33.7-1.8 45.1-36.4 30-66.2 41.1-91.1 50.4-9.2 3.4-69 19.3-98.7 98.1-8.9 23.6-46.7 134.7-188.9 187.7-15.8 5.9-27.3 10.2-40.9 20.2-4.5 3.4-12.8 6.1-18.4 6.1-7 0-16.7-4-21.7-8.9l-37.7-37.4c30.1-27.7 52.9-36.3 76.7-45.3 28.3-10.6 57.5-21.5 97.3-61.3s50.8-69 61.4-97.3c9.8-26.3 19.1-51.2 54-86 34.9-34.8 59.7-44.2 86-54 26.1-9.8 53.1-20.2 88.3-52.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bacon.js
// module id = 641
// module chunks = 0